import { memo } from 'react';
import cx from 'classnames';
import { SvgIcon } from '@/components';

import {
  formatConnectionHopsValue,
  formatConnectionUsd,
  getCounterpartyEntityTypeLabel,
  getEntityTypeSvgIconName,
  type CounterpartyConnectionItem,
  type ConnectionsSegmentMode,
} from './CounterpartyConnections.helpers';

import styles from './CounterpartyConnections.module.sass';

export type CounterpartyConnectionTableRowProps = {
  connection: CounterpartyConnectionItem;
  connectionAmountDivisor?: number;
  segment: ConnectionsSegmentMode;
};

export const CounterpartyConnectionTableRow = memo(
  function CounterpartyConnectionTableRow({
    connection,
    connectionAmountDivisor,
    segment,
  }: CounterpartyConnectionTableRowProps) {
    const title = connection.entity?.name || connection.entity?.slug || '';
    const typeIconName = getEntityTypeSvgIconName(connection.entity?.type);
    const typeLine = getCounterpartyEntityTypeLabel(connection.entity?.type);
    const receivedRaw =
      segment === 'direct'
        ? connection.received?.direct
        : connection.received?.total;
    const sentRaw =
      segment === 'direct' ? connection.sent?.direct : connection.sent?.total;
    const receivedUsd = formatConnectionUsd(
      receivedRaw,
      connectionAmountDivisor,
    );
    const sentUsd = formatConnectionUsd(sentRaw, connectionAmountDivisor);
    const receivedHops = formatConnectionHopsValue(connection.received?.hops);
    const sentHops = formatConnectionHopsValue(connection.sent?.hops);

    return (
      <div className={cx(styles.row, styles.gridRow)}>
        <div className={styles.rowName}>
          <div className={styles.entityName}>{title}</div>
        </div>
        <div className={styles.rowType}>
          {typeIconName ? (
            <SvgIcon name={typeIconName} className={styles.typeIcon} />
          ) : null}
          {typeLine ? (
            <div className={styles.entityType}>{typeLine}</div>
          ) : null}
        </div>
        <div className={styles.cellUsd}>{receivedUsd}</div>
        <div className={styles.cellHops}>{receivedHops}</div>
        <div className={styles.cellUsd}>{sentUsd}</div>
        <div className={styles.cellHops}>{sentHops}</div>
      </div>
    );
  },
);
